<ng-container *ngIf="control">
  <div>
    <label class="form-control-label" [for]="control.key">{{ control.label }}</label>
    <span class="required-text" *ngIf="required || isRequired()"> * </span>
  </div>
  <hb-action-button
    id="overrideValueBtn"
    class="override-value-button"
    *ngIf="!!control.syncAlgorithmId && (!control.formControl.isDisabled || control.overridingInProgress)"
    [icon]="control.previousValue || control.previousValue === '' || (control.controlType.toLowerCase() === 'checkbox' && control.previousValue == '0') ? 'ban' : 'refresh'"
    [title]="control.previousValue || control.previousValue === '' || (control.controlType.toLowerCase() === 'checkbox' && control.previousValue == '0') ? ('NodeInputSyncOverride.ClearValue' | i18next) : ('NodeInputSyncOverride.CalculateValue' | i18next)"
    [iconStyles]="control.overridingInProgress ? actionButtonIconStylesWithAnimation : actionButtonIconStyles"
    [buttonStyles]="actionButtonStyles"
    (clickEvent)="overrideValue()"
    [styleHover]="false"
    [disableOutline]="true"
  ></hb-action-button>
</ng-container>
